import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
  FormBuilder,
  AbstractControl,
  ValidatorFn,
} from "@angular/forms";
import * as CryptoJS from 'crypto-js';
import { CustomValidators } from "../../../../core/custom-validator/custom-validators";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../../../providers/user.service";
import { MessageService } from "primeng/api";
import { environment } from "../../../../../environments/environment";
import { CommonService } from "../../../../providers/common.service";
import { DOCUMENT } from "@angular/common";
import { AuthService } from "src/app/providers/auth.service";
import { isEmpty } from "lodash";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: "app-password-reset",
  templateUrl: "./password-reset.component.html",
  styleUrls: ["./password-reset.component.scss"],
  providers: [MessageService],
})
export class PasswordResetComponent implements OnInit, OnDestroy {
  public resetForm: UntypedFormGroup;
  displayBasic: boolean;
  queryParams = {};
  isLoading:boolean = false;
  defaultURL = environment?.defaultLogo;
  loginLogo:any
  tagName:any
  imageUrl = environment.whitelabelLogoPath;
  public formError: any = {};
  showHidePassword:boolean;
  showHideConfirmPassword:boolean;
  private confirmationModalOpen = false;
  private isNavigatingAway = false;
  private popStateHandler: any;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private messageService: MessageService,
    public commonService: CommonService,
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
	private ngbModal: NgbModal,

  ) {
    //console.log(this.route.snapshot.queryParams);
  }

  ngOnInit(): void {
    this.authService.defaultTheme(); 
    let whitelabelResData = JSON.parse(localStorage.getItem('whitelabelResData'));
    if (!isEmpty(whitelabelResData)) {
      this.loginLogo = `${this.imageUrl}/${whitelabelResData.logo_Login}`
      this.tagName = whitelabelResData.tagName
    }
  this.queryParams = this.initializeResetCredentials();
    this.resetForm = this.createForgotPasswordForm();
    this.resetForm.get('password')?.valueChanges.subscribe(() => {
    this.resetForm.get('cpassword')?.updateValueAndValidity({ onlySelf: true });
  });

  this.addHistoryState();
  this.popStateHandler = this.handlePopState.bind(this);
  window.addEventListener('popstate', this.popStateHandler);
}

ngOnDestroy(): void {
	if (this.popStateHandler) {
		window.removeEventListener('popstate', this.popStateHandler);
	}
}

private addHistoryState(): void {
	history.pushState({ passwordReset: true }, '', window.location.href);
}

private handlePopState(event: PopStateEvent): void {
	if (this.isNavigatingAway) {
	  return;
    }
    if (this.confirmationModalOpen) {
		history.pushState({ passwordReset: true }, '', window.location.href);
		return;
	}
	history.pushState({ passwordReset: true }, '', window.location.href);
	this.confirmationModalOpen = true;
	const modalRef = this.ngbModal.open(ConfirmationDialogComponent, { ariaLabelledBy: 'modal-basic-title', centered:true, backdrop: 'static', keyboard: false, });
	modalRef.componentInstance.header = 'Return to login';
	modalRef.componentInstance.confirmMsg = 'Are you sure you want to go back to the login page?';
	modalRef.componentInstance.body = '';
	modalRef.componentInstance.confirmButtonLabel = 'OK';
	modalRef.componentInstance.cancelButtonLabel = 'Cancel';

	modalRef.result.then((result) => {
	this.confirmationModalOpen = false;
		if (result === 'confirm') {
			this.isNavigatingAway = true;
			this.router.navigate(['/auth/login']);
		}
	}).catch(() => {
		this.confirmationModalOpen = false;
    });
}	

private initializeResetCredentials(): any {
	const params = this.getQueryParams();
	const stored = JSON.parse(sessionStorage.getItem(this.commonService.sessionStorageKeys.passwordReset) || 'null');
	const paramUserId = params?.userId ? `${params.userId}`.trim() : '';
	const paramToken = typeof params?.token === 'string' ? params.token.trim() : '';
	const storedUserId = stored?.userId ? `${stored.userId}`.trim() : '';
	const storedToken = typeof stored?.token === 'string' ? stored.token.trim() : '';
	if (paramUserId && paramToken) {
		sessionStorage.setItem(this.commonService.sessionStorageKeys.passwordReset, JSON.stringify({
			userId: paramUserId,
			token: paramToken
		}));
		window.history.replaceState({}, '', window.location.pathname);
		return { userId: paramUserId, token: paramToken };
	}
	if (storedUserId && storedToken) {
		return { userId: storedUserId, token: storedToken };
	}
	return {};
}


private getQueryParams(): any {
	const params = this.route.snapshot.queryParams || {};
	if (Object.keys(params).length > 0) {
		return params;
	}

	const search = window.location.search;
	if (!search) {
		return {};
	}

	const urlParams = new URLSearchParams(search);
	const parsed: any = {};
	urlParams.forEach((value, key) => {
		parsed[key] = value;
	});
	return parsed;
  }

  consecutiveCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const password = control.value;
      if (!password) {
        return null; // If no value, return null (no error)
      }
  
      // Check for consecutive alphabets
      for (let i = 0; i < password.length - 1; i++) {
        const currentChar = password[i];
        const nextChar = password[i + 1];
  
        if (/[a-zA-Z]/.test(currentChar) && /[a-zA-Z]/.test(nextChar) && nextChar.charCodeAt(0) === currentChar.charCodeAt(0) + 1) {
          return { consecutiveCharacters: true }; // Return error if consecutive alphabets found
        }
      }
  
      // Check for consecutive numbers
      for (let i = 0; i < password.length - 1; i++) {
        const currentChar = password[i];
        const nextChar = password[i + 1];
  
        if (/\d/.test(currentChar) && /\d/.test(nextChar) && nextChar.charCodeAt(0) === currentChar.charCodeAt(0) + 1) {
          return { consecutiveCharacters: true }; // Return error if consecutive numbers found
        }
      }
  
      return null; // No consecutive characters found, return null (no error)
    };
  }
  
  createForgotPasswordForm(): UntypedFormGroup {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})/ ;
    return this.formBuilder.group(
      {
        password: [
          "",
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(25),
            CustomValidators.EnhancedPatternValidator(),
            // this.consecutiveCharactersValidator()
          ],
        ],
        cpassword: ["", [Validators.required]],
      },
      { validators: CustomValidators.PassswordMatch }
    );
  }
  getPasswordErrorMessage(): string | null {
    const errors = this.resetForm.get('password')?.errors;
    
    if (!errors) return null; 
    const errorMessages: { [key: string]: string } = {
      required: "Password is required.",
      minLengthError: "Password must be at least 8 characters long.",
      missingUppercase: "Password must contain at least one uppercase letter.",
      missingLowercase: "Password must contain at least one lowercase letter.",
      missingNumber: "Password must contain at least one number.",
      missingSpecialCharacter: "Password must contain at least one special character.",
      maxLengthError: "Password must not greater than 25 characters long.",
    };

    for (const key of Object.keys(errorMessages)) {
      if (errors[key]) {
        return errorMessages[key]; 
      }
    }
    return null;
  }


  onFormSubmit() {
    if (!this.resetForm.valid) {
      this.validateAllFields(this.resetForm);
      //this.showSuccessDialog();
    } else {
      this.passwordReset(this.resetForm.value, this.queryParams);
      this.isLoading = true;
    }
  }

  validateAllFields(form: UntypedFormGroup) {
    Object.keys(form.controls).forEach((field) => {
      const control = form.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  passwordReset(resetForm, queryParams) {
	const finalParams = queryParams && Object.keys(queryParams).length ? queryParams : this.getQueryParams();
	const resetUserId = finalParams?.userId || finalParams?.id ? `${finalParams?.userId || finalParams?.id}`.trim() : '';
	const resetToken = typeof finalParams?.token === 'string' ? finalParams.token.trim() : '';
	if (!resetUserId || !resetToken) {
      let errMsg = {
        status: "Unauthorized Access",
        message: "You do not have permission to reset password",
      };

      this.showAlert(errMsg, "error");
    } else {
      let encryptedPassword = this.encryptPassword(resetForm.password);
      let encryptedConfirmPassword = this.encryptPassword(resetForm.cpassword);
      resetForm.password = encryptedPassword;
      resetForm.cpassword = encryptedConfirmPassword;
      let formData = {
        ...resetForm,
			token: resetToken,
      };
      this.userService.resetPassword(formData).subscribe(
        (res) => {
          // this.showAlert(
          //   { status: "Success!", message: res.message },
          //   "success"
          // );
          //
                sessionStorage.removeItem(this.commonService.sessionStorageKeys.passwordReset);
          this.showSuccessDialog();
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          if (err?.type == 'MODAL') {
            this.authService.showModal(err);
          } else {
            this.showAlert(err, "error");
          }
        }
      );
    }
  }

  encryptPassword(password) {
    return CryptoJS.AES.encrypt(password, this.commonService.getAccountPersonalData('pstwd')).toString();
  }

  decryptPassword(password) {
    return CryptoJS.AES.decrypt(password, this.commonService.getAccountPersonalData('pstwd')).toString(CryptoJS.enc.Utf8);
  }

  goToLogin() {
    this.displayBasic = false;
    this.isLoading = false;
    this.router.navigate(["/auth/login"]);
  }

  showAlert(data, alertType) {
    this.messageService.add({
      severity: alertType,
      summary: data.status,
      detail: data.message,
      life: 5000,
    });
  }

  showSuccessDialog() {
    this.displayBasic = true;
  }
  showpassword(){
    this.showHidePassword = !this.showHidePassword;
  }
  showconfirmpassword(){
    this.showHideConfirmPassword = !this.showHideConfirmPassword;
  }
}
